export default __webpack_public_path__ + "static/media/sponsors_gradient.abdf9a80.png";